export default {
  methods: {
    paginateFilter(paginate) {
      if (!paginate || !paginate.data || paginate.data.length === 0) {
        return paginate
      }
      let pageSize = JSON.parse(JSON.stringify(paginate.pageSize)),
        data = JSON.parse(JSON.stringify(paginate.data)),
        total = data.length,
        pageCount = Math.ceil(total / pageSize)

      let newObj = {}
      if (data) {
        for (let i = 0; i < pageCount; i++) {
          newObj[i + 1] = data.splice(0, pageSize)
        }
      }
      let newData = {
        data: newObj, //数组数据
        total: total, // 总数
        page: pageCount === 1 ? 1 : paginate.page, // 第几页
        pageSize: pageSize, //每页条数
        pageCount: pageCount
      }
      // console.log(newData)
      return newData
    }
  }
}
